import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const UnitRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.unit_master_create === true ||
    permissions.unit_master_edit === true ||
    permissions.unit_master_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default UnitRouteMiddleware;
